import { Button, Skeleton } from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import React from 'react';
import { homeStyles } from '..';

export function MobileYTShort(props: {
  videoSRC: string;
  isPlaylist: boolean;
}) {
  // State
  const [hide, setHide] = React.useState(false);

  return (
    <Stack width="100%" spacing={1} alignItems="center" justifyContent="center">
      {hide ? null : (
        <Box
          sx={{
            width: '100%',
            borderRadius: 5,
            overflow: 'hidden',
            aspectRatio: '9 / 16',
            position: 'relative',
          }}
        >
          <Skeleton variant="rectangular" height="100%" width="100%" />
          <iframe
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
            src={`${props.videoSRC}${
              props.isPlaylist ? '&' : '?'
            }autoplay=1&mute=1`}
            title="featured youtube short"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture;"
            allowFullScreen
            loading="eager"
          />
        </Box>
      )}

      <Button
        fullWidth
        sx={{ ...homeStyles.button }}
        onClick={() => setHide(!hide)}
      >
        {hide ? 'Check Out Latest Video' : 'Hide'}
      </Button>
    </Stack>
  );
}
